import React, { Fragment } from "react";

import Button from "../../Buttons/Button/Button";

interface Props {
    children?: GenericModalChildren;
    onClick: () => void;
}

const FlyoutTrigger = ({ children, onClick }: Props) => {
    if (children) {
        const child = React.Children.only(children);
        return (
            <Fragment>
                {React.cloneElement(
                    child,
                    {
                        onClick,
                    },
                    child?.props?.children
                )}
            </Fragment>
        );
    }

    return (
        <Button type="button" onClick={onClick}>
            'button Text'
        </Button>
    );
};

export default FlyoutTrigger;
